import  { useEffect, useRef, useState } from "react";

import ExpenseList from "./components/ExpenseList";
import ExpenseForm from "./components/ExpenseForm";
import Summary from "./components/Summary";

//Same type as above 
type Expense ={
  id: number;
  description: string;
  amount: number;
  category: string;
};

function App() {
  //Dummy data with proper types
  const [expenses, setExpenses] =  useState<Expense[]>([]);
 
  //Load from localStorage when app starts
  useEffect(() => {
    const saved = localStorage.getItem('expenses');
    if(saved) {
      try {
        setExpenses(JSON.parse(saved));
      } catch (e) {
        console.error('Failed to load expenses:', e);
      }
    }
  }, []); // empty array = run once on mount
//
  const descriptionRef = useRef<HTMLInputElement>(null);
  const [sortBy, setSortBy] = useState<'newest' | 'oldest' | 'highest' | 'lowest' > ('newest');
  const [filterCategory, setFilterCategory] = useState<string>('All');
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  //
  let displayedExpenses = [...expenses];

  // Filter
  if(filterCategory !== 'All') {
    displayedExpenses = displayedExpenses.filter(exp => exp.category === filterCategory);
  }
  // Sort
  displayedExpenses.sort((a, b) => {
    if (sortBy === 'newest') return b.id - a.id;
    if(sortBy === 'oldest') return a.id - b.id;
    if(sortBy === 'highest') return b.amount - a.amount;
    if(sortBy === 'lowest') return a.amount - b.amount;
    return 0;
  });
  useEffect(() => {
    if(descriptionRef.current) {
      descriptionRef.current.focus();
    }
  }, []); // Focus on first load

  //save to localStorage whenever expenses change 
  useEffect(() =>{
    localStorage.setItem('expenses', JSON.stringify(expenses));

  }, [expenses]); // run when expenses updates

  
  const handleClearAll = () => {
    if(window.confirm('Are you sure you want to delete all expenses?')) {
      setExpenses([]);
    }
  };

  // New: Calculate total spent
  const totalSpent = expenses.reduce((sum, exp) => sum + exp.amount, 0);

  // New: Group by category
  const categorySummary = expenses.reduce((acc: Record<string, number>, exp) =>{
    acc[exp.category] = (acc[exp.category] || 0) + exp.amount;
    return acc;
  }, {});

  const handleDelete = (id: number) => {
    const expenseToDelete = expenses.find(exp => exp.id === id);
    if (!expenseToDelete) return;
    if(window.confirm('Delete this expense?')) {
      setLastAction({
        type: 'delete',
        expense: expenseToDelete,
      });
      setExpenses(prev => prev.filter(exp => exp.id !== id));
      setShowUndoToast(true);
      setTimeout(() => setShowUndoToast(false), 5000);
    }
  }

  const handleEdit = (updatedExpense: Expense) => {
    const oldExpense = expenses.find(exp => exp.id === updatedExpense.id);
    if (!oldExpense) return;
    setLastAction({
      type: 'edit',
      expense: oldExpense, //save old version
    });

    setExpenses(

      expenses.map((exp) => 
        exp.id === updatedExpense.id ? updatedExpense : exp)
    );
    setShowUndoToast(true);
    setTimeout(() => setShowUndoToast(false), 5000);
  };

  //
  const filteredCategorySummary = displayedExpenses.reduce((acc: Record<string, number>, exp) => {
    acc[exp.category] = (acc[exp.category] || 0) + exp.amount;
    return acc;
  }, {});
  //
  const handleUndo = () => {
    if (!lastAction) return;

    if (lastAction.type === 'delete'){
      setExpenses(prev => [...prev, lastAction.expense]);

    }else if (lastAction.type === 'edit'){
      setExpenses(prev => 
        prev.map(exp =>
          exp.id === lastAction.expense.id ? lastAction.expense : exp
        )
      );
    }
    setLastAction(null);
    setShowUndoToast(false);
  }

  //
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  }
  //
  const [lastAction, setLastAction] = useState<{
    type: 'delete' | 'edit' ;
    expense: Expense;
    previousExpenses?: Expense[]; // for edit, we need old list 
  } | null>(null);
  const [showUndoToast, setShowUndoToast] = useState(false);
  
return (
  <>
    

    <div className="app-container">
      <button className="toggle"
      onClick={toggleTheme}
    >
      {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
    </button>
       
      <h1>Personal Finance Tracker</h1>

      <Summary 
        totalSpent={totalSpent}
        categorySummary={filteredCategorySummary || categorySummary}
        />

  
      <ExpenseForm
        onAddExpense={(newExp) => {
          const expenseToAdd = {
            id: Date.now(),
            ...newExp,
          };
          setExpenses([...expenses, expenseToAdd]);
        }}
        />
    
     <button onClick={handleClearAll} className="clear-button">Clear All Expenses</button>
      
      {/*  */}
      <h2>Recent Expenses</h2>
        <div style={{ 
                margin: '24px 0', display: 'flex', gap: '16px', flexWrap: 'wrap'

      }}
      >
        <div>
          <label>Sort by: </label>
          <select 
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value as typeof sortBy)}
            style={{ padding: '8px'}}
            >
              <option value={"newest"} >Newest</option>
              <option value="oldest">Oldest first</option>
              <option value="highest">Highest amount</option>
              <option value="lowest">Lowest amount</option>
            </select>
        </div>
        <div>
          <label>Filter category: </label>
          <select 
            value={filterCategory} 
            onChange={(e) => setFilterCategory(e.target.value)}
            style={{ padding: '8px' }}
          >
            <option value="All">All</option>
            <option value="Food">Food</option>
            <option value="Transport">Transport</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>
      <ExpenseList expenses={displayedExpenses} 
                    onDelete={handleDelete}
                    onEdit={handleEdit} />

      
      </div>

      {showUndoToast && lastAction && (
          <div className="undo-toast">
            <span> {lastAction.type === 'delete' ? 'Expense deleted.' : 'Expense updated.'} </span>
            <button
              onClick={handleUndo}
              className="undo-btn"
              > Undo</button>
              <button 
                onClick={() => setShowUndoToast(false)}
                className="close"
                >×</button>

          </div>
      )}
    </>
  )
}

export default App;